import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { injectIntl, FormattedMessage } from 'react-intl';

import useScheduleChangedQuery from 'components/queries/useScheduleChangedQuery';

import {
  ScheduleChangedContainer,
  ScheduleChangedContent,
  ScheduleChangedEmpty,
  ScheduleChangedLoading,
  ScheduleChangedIcon
} from './ScheduleChangedAlert.style';

const ScheduleChangedAlert = ({ journey: { uuid: segmentId } }) => {
  const { reference: bookingReference } = useParams();
  const { data, loading } = useScheduleChangedQuery({ bookingReference, segmentId });

  if (loading) {
    return <ScheduleChangedLoading data-testid="schedule-changed-loading" />;
  }

  if (!data) {
    return <ScheduleChangedEmpty data-testid="schedule-changed-empty" />;
  }

  const popupId = `${segmentId}-schedule-changed`;
  const {
    scheduleChange: { content }
  } = data;

  return (
    <>
      <ScheduleChangedContainer data-for={popupId} data-tip>
        <FormattedMessage id="journeySegment.scheduleChangeWarning" />
        <ScheduleChangedIcon icon="Information" />
      </ScheduleChangedContainer>
      <ReactTooltip className="tooltip" id={popupId} data-testid={popupId}>
        <ScheduleChangedContent>{content}</ScheduleChangedContent>
      </ReactTooltip>
    </>
  );
};

ScheduleChangedAlert.propTypes = {
  journey: PropTypes.shape({
    uuid: PropTypes.string.isRequired
  }).isRequired
};

export default injectIntl(ScheduleChangedAlert);
